import React from "react"
import { Link } from "gatsby"
// import i18n from "../../translation/i18next"
// import { withTranslation } from "react-i18next"
// import Select from "@material-ui/core/Select"
// import LanguageSelect from "./LanguageSelect"

import MobileHeader from "./MobileHeader"

import szechenyi_logo from "../../assets/images/szechenyi-desktop.webp"
import szechenyi_logo_jpg from "../../assets/images/szechenyi_logo.jpg"

import "./header.scss"

const Header = (props) => {
  // const [language, setLanguage] = useState("hu")

  // const handleClick = lang => {
  //   setLanguage(lang)
  //   i18n.changeLanguage(lang)
  // }

  return (
    <div className="header-wrapper">
      <div
        className="header"
        style={{
          background: `${
            props.shaded
              ? `linear-gradient(to right, #484848 0%, transparent),`
              : ""
          } url(${props.background ? props.background : ""}) no-repeat right`,
          backgroundSize: "50%",
          backgroundColor: `${props.background ? "#484848" : ""}`,
          paddingRight: `${props.logo ? "0px" : "5%"}`,
        }}
      >
        <div className="logo_wrapper">
          <div className="logo">
            <Link to="/">
              <img
                src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${props.logo.path}`}
                alt="prodhost_logo"
                aria-label="prodhost_logo"
              />
            </Link>
          </div>
        </div>
        <div className="headline">
          <div className="headline_1">{props.header_title}</div>
          <div className="headline_2">{props.header_description}</div>
        </div>
        {props.logo ? (
          <Link to="/szechenyi-2020" className="szechenyi_logo_wrapper">
            <img
              className="szechenyi_logo"
              src={szechenyi_logo}
              alt="szechenyi_logo"
              aria-label="szechenyi_logo"
            />
          </Link>
        ) : null}
        <div
          className="icons"
          style={{
            marginRight: `${props.logo ? "200px" : "0px"}`,
          }}
        >
          {/* <LanguageSelect /> */}
          {/* <Select
            className="language-select"
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
            }}
            defaultValue={"hu"}
            value={language}
            onChange={e => handleClick(e.target.value)}
          >
            <option value={"hu"}>HU</option>
            <option value={"en"}>EN</option>
          </Select> */}
        </div>
      </div>
      <MobileHeader
        logo={props.logo}
        items={props.items}
        color={props.color ? props.color : "white"}
        selected={props.selected}
        selected2={props.selected2}
        selected3={props.selected3}
        expanded={props.expanded}
      />
    </div>
  )
}

export default /* withTranslation() */ Header
